module.exports = __webpack_public_path__ + "static/media/6.78866333.jpg";